module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1013.69b751f9.png";